module.exports = __webpack_public_path__ + "static/media/no-wifi.726da752.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/no-wifi.svg
// module id = 164
// module chunks = 0